import { getLocaleHeader } from "@lib/util/get-locale-header"
import Medusa, { FetchArgs, FetchInput } from "@medusajs/js-sdk"

const getBackendUrl = () => {
  if (typeof window !== "undefined") {
    return `${window.location.protocol}//${window.location.hostname}:9000`
  }
  return process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL || "http://127.0.0.1:9000"
}

export const sdk = new Medusa({
  baseUrl: getBackendUrl(),
  debug: process.env.NODE_ENV === "development",
  publishableKey: process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY,
})

if (typeof window !== "undefined") {
  ;(sdk.client as any).config.baseUrl = `${window.location.protocol}//${window.location.hostname}:9000`
}

const originalFetch = sdk.client.fetch.bind(sdk.client)

sdk.client.fetch = async <T>(
  input: FetchInput,
  init?: FetchArgs
): Promise<T> => {
  if (typeof window !== "undefined") {
    const targetHost = `${window.location.hostname}:9000`
    ;(sdk.client as any).config.baseUrl = `${window.location.protocol}//${targetHost}`

    if (typeof input === "string") {
      input = input.replace(/http:\/\/(localhost|127\.0\.0\.1):9000/, `${window.location.protocol}//${targetHost}`)
    } else if (input instanceof URL) {
      if (input.hostname === "localhost" || input.hostname === "127.0.0.1") {
        input = new URL(input.pathname + input.search, `${window.location.protocol}//${targetHost}`)
      }
    }
  }

  const headers = init?.headers ?? {}
  let localeHeader: Record<string, string | null> | undefined
  try {
    localeHeader = await getLocaleHeader()
    headers["x-medusa-locale"] ??= localeHeader["x-medusa-locale"]
  } catch {}

  const newHeaders = {
    ...localeHeader,
    ...headers,
  }
  init = {
    ...init,
    headers: newHeaders,
  }
  return originalFetch(input, init)
}
